import { CSSProperties, useState } from 'react';
import { InfoButtonView } from './search-buttons/info-button.component';
import { SearchButtonView } from './search-buttons/search-button.component';
import { WelcomeModalComponent } from '@vivli/shared/components';
import { useActiveUserContext, useModalApiContext, useSearchApiContext } from '@vivli/core/infrastructure/context';
import { ExportCsvButtonView } from '@vivli/shared/views';

const inputButtonsContainerStyle: CSSProperties = {
    display: 'flex',
    paddingTop: '0',
};

const closeButtonStyle = (isHovering: boolean): CSSProperties => ({
    cursor: 'pointer',
    height: '60px',
    width: '140px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: isHovering ? 'grey' : 'initial',
});

export const SearchInputButtonsComponent = () => {
    const { user: activeUser } = useActiveUserContext();
    const modalService = useModalApiContext();
    const [isHovering, setIsHovering] = useState(false);
    const { toggleIsShowingResults, isShowingResults, searchResults, callExport, retrievingStudiesCsv } = useSearchApiContext();

    const handleInfoButtonClick = () => {
        const modalId = modalService.custom(<WelcomeModalComponent onClose={() => modalService.dismiss(modalId)} />, {
            style: { minWidth: '850px' },
        });
    };

    const exportToCsv = (e) => {
        e.stopPropagation();
        callExport();
        return false;
    };

    return (
        <div style={inputButtonsContainerStyle}>
            {!isShowingResults && (
                <>
                    <InfoButtonView onClick={handleInfoButtonClick} />
                    <SearchButtonView onClick={toggleIsShowingResults} />
                </>
            )}

            {isShowingResults && activeUser == null && (
                <div
                    style={closeButtonStyle(isHovering)}
                    onMouseEnter={() => setIsHovering(true)}
                    onMouseLeave={() => setIsHovering(false)}
                    onClick={toggleIsShowingResults}
                >
                    CLOSE
                </div>
            )}

            {isShowingResults && activeUser != null && (
                <>
                    <div
                        style={closeButtonStyle(isHovering)}
                        onMouseEnter={() => setIsHovering(true)}
                        onMouseLeave={() => setIsHovering(false)}
                        onClick={toggleIsShowingResults}
                    >
                        <ExportCsvButtonView onClick={exportToCsv} isLoading={retrievingStudiesCsv} showDownloadingText={true} />
                        CLOSE
                    </div>
                </>
            )}
        </div>
    );
};
